export default __webpack_public_path__ + "static/media/magical-5.460f25e7.jpg";